import React from 'react'
import { useDispatch } from 'react-redux'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { LogoutIcon } from '@heroicons/react/solid'

import { logout } from '../../actions/auth.actions'

export default function Logout() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleLogout = async (e) => {
    e.preventDefault()
    dispatch(logout())
    navigate('/login')
  }

  return (
    <div className="flex items-center">
        <LogoutIcon className="h-8 w-8 pr-2" />
        <button onClick={(e) => { handleLogout(e) }}>
          log out
        </button>
    </div>
  );
}